/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import * as z from "zod";

export const getStringValidator = (validator: any) => {
  let newz = z.string();

  if (validator) {
    validator.forEach((rule: any) => {
      if (rule && rule.rule === "regex") {
        newz = newz.regex(
          new RegExp(rule.condition as unknown as string),
          rule?.message ?? "The input must satisfy regex expression"
        );
      }
      const maxLength = rule.condition as unknown as string;
      if (rule) {
        const maxLength = rule.condition as unknown as string;
        if (rule.rule === "maxLength") {
          newz = newz.max(
            +maxLength,
            rule?.message ?? `The maximum length of input can be ${maxLength}`
          );
        }
        if (rule.rule === "notAllowedWords") {
          let disallowedWords = (rule.condition as unknown as string)
            .split(",")
            .map((s) => s.trim())
            .join("|");

          let regex = new RegExp("^(?!.*(" + disallowedWords + ")).*$", "i");

          newz = newz.regex(
            regex,
            rule?.message ?? `The input must not contain ${disallowedWords.split("|").join(",")}`
          );
        }
      }
    });
  }
  return newz;
};
